'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserSources } from '../../Entities/User/UserSources';
import { UserSourcesCollection } from '../../Collections/User/UserSourcesCollection';
import type { APICriteria, APIOptions } from '@api/API/CoreAPI';

/**
 * Searchable fields
 */
export type UserSourcesCriteria = {
  sourceName: string;
};

export type UserSourcesAPIInclude = null;

/**
 * Criteria & include
 */
export type UserSourcesAPICriteria = APICriteria<UserSourcesCriteria>;

export type UserSourcesAPIOptions = APIOptions<UserSourcesAPICriteria, UserSourcesAPIInclude>;

export class UserSourcesRepository extends CoreRepository {
  public getUserSources(
    userId: number,
    options: UserSourcesAPIOptions = null,
    criteria: UserSourcesAPICriteria = null
  ) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options.criteria = criteria;
    }

    return this.webAPI.getUserSources(userId, options).then((response) => {
      const collection = new UserSourcesCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserSources();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public addUserSource(userId: number, payload: object = {}) {
    return this.webAPI.addUserSource(userId, payload).then((response) => {
      const item = new UserSources();
      item.hydrate(response);

      return item;
    });
  }
}
